// API ROOT URL
// export const API_ROOT_URL = "https://api.farmakom.it/v1/sales";
export const API_ROOT_URL = "https://api.farmakom.io/v1/sales";

export const API_CONTRACT_URL = "https://api.farmakom.it/contracts/";

// LOCAL LOGIN
// If true it doesn't redirect to the external URL (for local testing)
export const LOCAL_LOGIN = true;
